import React from "react";
import { Link } from "react-router-dom";
import { getBrandName } from "../../Components/getBrandName";
import LandingPage from "../Landing/LandingPage";

const Footer = () => {
  const { normalizedBrand, brandName } = getBrandName();

  return (
    <>
      {/* Footer page*/}
      <LandingPage />
    </>
  );
};

export default Footer;
